import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SectionTitle.module.css';

const SectionTitle = ({ title, subtitle, titleClassName }) => (
  <div className={styles.container}>
    <h1 className={classNames(styles.title, titleClassName)}>{title}</h1>
    <p className={styles.subtitle}>{subtitle}</p>
  </div>
);

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
};

SectionTitle.defaultProps = {
  titleClassName: null,
};

export default SectionTitle;
